import { defaultCountries, parseCountry, buildCountryData, ParsedCountry } from 'react-international-phone';

export const countries = defaultCountries.map((country) => {
  const parsedCountry = parseCountry(country);

  if (parsedCountry.iso2 === 'ar') {
    parsedCountry.format = {
      default: '..............',
    };
  }

  return buildCountryData(parsedCountry);
});

export type PhoneInputOnchangeData = {
  country: ParsedCountry;
  inputValue: string;
};
